// extracted by mini-css-extract-plugin
module.exports = {"doubleSubtitle":"DoubleSubtitle_doubleSubtitle__37tm3","doubleContent":"DoubleSubtitle_doubleContent__29wCM","subtitle":"DoubleSubtitle_subtitle__3vWqN"};